export default class studyManager {
    constructor(effect) {

        this.pointIcon;

        this.effect = effect;
    }

    init() {
        this.pointIcon = document.querySelectorAll('[data-point-background]')
        this.pointIconAnimation();
    }
    pointIconAnimation() {
        if(!this.pointIcon) return;
        TweenMax.staggerTo(this.pointIcon,0, {
            opacity: 1,
        },0)
        this.pointtl = new TimelineMax({repeat:-1,repeatDelay:0.9});
        this.pointAnime = this.pointtl.staggerTo(this.pointIcon,.9, {
            opacity: 0,
            scale: 1.2,
        },0).staggerTo(this.pointIcon,0, {
            scale: 0.6,
        },0);
    }
}